export default __webpack_public_path__ + "static/media/face5.cc6c57be.svg";